// extracted by mini-css-extract-plugin
export default {"container":"styles_container__y30Ry","cards":"styles_cards__LccgQ","content":"styles_content__W5F6R","img":"styles_img__SMSd6"};